export default __webpack_public_path__ + "static/media/show_3 1.4d2ef198.svg";